<section class="irrigator-auth-panel" aria-labelledby="guard-auth-title">
  <button type="button" class="auth-back" (click)="backToProfileSelection()">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m15 18-6-6 6-6" />
    </svg>
    Volver
  </button>

  <div class="login-copy">
    <p class="login-kicker">Acceso de guardas</p>
    <h1 id="guard-auth-title">Autenticacion de guarda</h1>
  </div>

  <form class="receipt-auth-form" (submit)="authenticateGuard($event)">
    <label>
      <span>Usuario</span>
      <input
        type="text"
        name="username"
        [(ngModel)]="username"
        autocomplete="username"
      />
    </label>

    <label>
      <span>Contrasena</span>
      <input
        type="password"
        name="password"
        [(ngModel)]="password"
        autocomplete="current-password"
      />
    </label>

    @if (guardAuthError) {
      <p class="auth-error" role="alert">{{ guardAuthError }}</p>
    }

    <button type="submit" class="auth-submit" [disabled]="guardAuthLoading">
      {{ guardAuthLoading ? 'Comprobando...' : 'Acceder como guarda' }}
    </button>
  </form>
</section>
